import { Date } from "Controls/Date";

/**
 * Control for hidden date input.
 * @since 4.0.0
 * @example
 * ```JavaScript
 * // Access the instance of a HiddenDate with ControlID 1337
 * // In script:
 * @@ctr:1337@@
 *
 * // On page:
 * $dms(1337)
 * ```
 */
export class HiddenDate extends Date {
    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-hiddendate";

    /**
     * Internal method for setElement.
     * @param element JQueryElement for initialization.
     * @hidden
     */
    protected setElementInternal(element: JQuery): void {
        element.attr("style", "display: none");
        super.setElementInternal(element);
    }

    /**
     * Gets the display template for formatting in grid row.
     * @hidden
     */
    protected getDisplayTemplate(bindingField?: string): string {
        return `#= "" #`;
    }
}
